import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { MenuItem, TextField } from '@material-ui/core';
import { PAYMENT_CYCLE_LIST, CONTRACT_SCREEN_MANAGEMENT, PAYMENT_STATUS } from '@/common/constant/NormalContractManagementConstant';
import { onChangeVersion } from '../EditOrganizationHandler';
import Constant from '@/common/constant/Constant';
import '../rootOrganization.css'
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CorporationContractInfo({
    selectedProduct,
    selectedEdition,
    selectedVersion,
    setSelectedVersion,
    listVersion,
    rootCorporationInfo,
    contractInfo,
    setIsEdit,
    corpActiveIsBlock
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const getPaymentCycle = () => {
        const paymentCycle = PAYMENT_CYCLE_LIST.find(payment => payment.code === contractInfo?.paymentCycle)
        if(!Utils.isEmpty(paymentCycle) && 
          rootCorporationInfo?.contractStatus !== Constant.CORPORATION_CONTRACT_TYPE.TRIAL
        ) {
            return tr(paymentCycle?.name);
        }
        return ''
    }

    const getPaymentMethod = () => {
        switch (contractInfo?.paymentMethod) {
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.BANK_TRANSFER:
                return tr('振込');
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.STRIPE:
                return tr('クレジットカード');
            default:
                return '';
        }
    }

    const getPaymentStatus = () => {
        switch (contractInfo?.paymentStatus) {
            case PAYMENT_STATUS.PROCESS:
                // return 'お試し';
            case PAYMENT_STATUS.SUCCESS:
                return tr('正常');
            case PAYMENT_STATUS.FAIL:
                return '';
            default:
                return '';
        }
    }

    return (
        <div className="wrapper-contract-info">
            <div className="block-one p-16">
                {/* product  */}
                <div>
                    <div className="label-autocomplete">{trI18n('CM-LABEL-PRODUCT-SELECTION')}</div>
                    <div className="form-addTicket-input">
                        <TextField
                            className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                            select
                            value={`${selectedProduct.label}`}
                            disabled
                            variant="outlined"
                            data-cy="header-top-select-project"
                            SelectProps={{
                                MenuProps: {
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null,
                                    className: 'selectDrop'
                                }
                            }}
                        >
                            <MenuItem
                                value={`${selectedProduct.label}`}
                            >
                                    <OverFlowTooltipWithTabsMui
                                        className='tooltip-product'
                                        value={selectedProduct.label}
                                    />
                            </MenuItem>
                        </TextField>
                    </div>
                </div>

                {/* edition  */}
                <div>
                    <div className="label-autocomplete">{trI18n('CM-LABEL-EDITION-SELECTION')}</div>
                    <div className="form-addTicket-input">
                        <TextField
                            className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                            select
                            value={`${selectedEdition.label}`}
                            disabled
                            variant="outlined"
                            data-cy="header-top-select-project"
                            SelectProps={{
                                MenuProps: {
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null,
                                    className: 'selectDrop'
                                }
                            }}
                        >
                            <MenuItem
                                value={`${selectedEdition.label}`}
                            >
                                    <OverFlowTooltipWithTabsMui
                                        className='tooltip-edition'
                                        value={selectedEdition.label}
                                    />
                            </MenuItem>
                        </TextField>
                    </div>
                </div>

                {/* version  */}
                <div>
                    <div className="label-autocomplete">{trI18n('CM-LABEL-VERSION-SELECTION')}</div>
                    <TextField
                        className="form-control form-control--wrap form-control--hg40"
                        select
                        disabled={corpActiveIsBlock}
                        variant="outlined"
                        name="selectedAdmin"
                        value={`${selectedVersion.label}`}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                        onChange={e => onChangeVersion(
                            e.target.value,
                            setSelectedVersion,
                            setIsEdit,
                            listVersion
                        )}
                        error={
                            Utils.isEmptyObject(selectedVersion) ||
                            selectedVersion?.id === null
                        }
                        helperText={
                            Utils.isEmptyObject(selectedVersion) ||
                            selectedVersion?.id === null
                                ? trI18n('COMMSG014')
                                : ''
                        }
                    >
                        {listVersion.map(version => {
                            return (
                                <MenuItem
                                    key={`admin-${version.id}`}
                                    value={version.label}
                                >
                                    <OverFlowTooltipWithTabsMui value={version.label}/>
                                </MenuItem>
                            );
                        })}
                    </TextField>
                </div>
            </div>

            <div className="block-two p-16">
                <div className="group-contract-date">
                    {/* start contract  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('契約開始日')}
                        </label>
                        <div className="form-addTicket-input">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                variant="outlined"
                                disabled={true}
                                value={Utils.getDateByFormatYYYY_MM_DD(
                                    contractInfo?.startDate
                                )}
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                        </div>
                    </div>

                    {/* expired contract  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('契約更新日')}
                        </label>
                        <div className="form-addTicket-input">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                variant="outlined"
                                disabled={true}
                                value={Utils.getDateByFormatYYYY_MM_DD(
                                    contractInfo.billEndDate
                                )}
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                        </div>
                    </div>

                    {/* update contract  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('追加契約日')}
                        </label>
                        <div className="form-addTicket-input">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                variant="outlined"
                                disabled={true}
                                value={Utils.getDateByFormatYYYY_MM_DD(
                                    contractInfo?.updatedAt
                                )}
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                        </div>
                    </div>
                </div>

                {/* next payment  */}
                {/* <div>
                    <label className="form-addTicket-label edit-organization-input-label">
                        クレジット引き落予定日 
                    </label>
                    <div className="form-addTicket-input">
                        <TextField
                            name="startDate"
                            className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                            variant="outlined"
                            disabled={true}
                            value=''
                            autoComplete="off"
                            data-cy="render-field-txt-input"
                        />
                    </div>
                </div> */}

                <div className="group-contract-date">
                    {/* payment cycle  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('請求サイクル')}
                        </label>
                        <div className="form-addTicket-input">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                variant="outlined"
                                disabled={true}
                                value={getPaymentCycle()}
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                        </div>
                    </div>

                    {/* usage fee  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('利用料金')}
                        </label>
                        <div className="form-addTicket-input flex-center gap-8">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                variant="outlined"
                                disabled={true}
                                value=""
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                            <span>{tr('円')}</span>
                        </div>
                    </div>
                </div>

                <div className="group-contract-date">
                    {/* payment method  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('支払方法')}
                        </label>
                        <div className="form-addTicket-input">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                variant="outlined"
                                disabled={true}
                                value={getPaymentMethod()}
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                        </div>
                    </div>

                    {/* payment status  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('支払状況')}
                        </label>
                        <div className="form-addTicket-input">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                variant="outlined"
                                disabled={true}
                                value={getPaymentStatus()}
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                        </div>
                    </div>
                </div>

                <div className="group-contract-date d-none">
                    {/* annual amount  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('値引年額')}
                        </label>
                        <div className="form-addTicket-input flex-center gap-8">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                variant="outlined"
                                value=""
                                disabled={true}
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                            <span>{tr('円')}</span>
                        </div>
                    </div>

                    {/* monthly discount  */}
                    <div className="flex-1">
                        <label className="form-addTicket-label edit-organization-input-label">
                            {tr('値引月額')}
                        </label>
                        <div className="form-addTicket-input flex-center gap-8">
                            <TextField
                                name="startDate"
                                className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                variant="outlined"
                                value=""
                                disabled={true}
                                autoComplete="off"
                                data-cy="render-field-txt-input"
                            />
                            <span>{tr('円')}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
